export default [
	{ text: 'Male', value: 'M' },
	{ text: 'Female', value: 'F' },
	{ text: 'Intersex or Indeterminate', value: 'I' },
	{ text: 'No stated', value: 'N' }
];



// WEBPACK FOOTER //
// ./src/data/sexes.js